(function () {
  function hideWiderrufWatermark() {
    document.querySelectorAll(".wf-iframe-container + div").forEach(function (el) {
      if (el.querySelector('a[href*="euwiderrufsbutton.de"]')) {
        el.style.setProperty("display", "none", "important");
      }
    });
  }

  function init() {
    hideWiderrufWatermark();
    if (!window.__euWiderrufWatermarkObserver) {
      window.__euWiderrufWatermarkObserver = new MutationObserver(hideWiderrufWatermark);
      window.__euWiderrufWatermarkObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", hideWiderrufWatermark);
})();
